import { getLanguage } from '@common/translate/translate';

type NullableBooleanProps = {
    readonly value?: boolean;
};

export function NullableBoolean({ value }: Readonly<NullableBooleanProps>) {
    const { common } = getLanguage();

    if (value === undefined) {
        return null;
    }

    return <span>{value ? common.yes : common.no}</span>;
}
